import { LocationState } from './useFromOnboarding.decl';

import { useLocation } from 'react-router-dom';

/**
 * Custom hook to know if the previous page was /onboarding.
 * @returns A boolean.
 */
export function useFromOnboarding(): boolean {
  const { state } = useLocation() as LocationState;

  return state?.from === '/onboarding';
}
